import Actions from "./Actions";
import { AssignedGroupsRenderer, UserNameRenderer } from "./CustomCells";
import {
  ACTION_CELL_STYLE,
  ACTION_COLUMN_FLEX,
  createField,
  createSelectionField,
} from "../../components/tableMetaHelpers";

export const getFilterMeta = (triggerRefresh, setTriggerRefresh, selectionConfig = null) => {
  const withSelection = Boolean(selectionConfig);
  const mainFlex = withSelection ? "0 1 18%" : "0 1 20%";
  const assignedFlex = withSelection ? "0 1 23%" : "0 1 25%";

  return {
    fields: {
      ...(withSelection
        ? createSelectionField({
            selectionConfig,
            testIdPrefix: "filter-assignment-checkbox",
            getItemId: (item) => item?.key || item?.id,
          })
        : {}),
      sharedWithGroups: createField("Assigned groups", assignedFlex, AssignedGroupsRenderer),
      filterName: createField("Filter name", mainFlex),
      columnSet: createField("Columns set", mainFlex),
      createdBy: createField("Created by", mainFlex),
      modifiedBy: createField("Modified by", mainFlex, UserNameRenderer),
      action: {
        ...createField(null, ACTION_COLUMN_FLEX, (props) => (
          <Actions {...props} triggerRefresh={triggerRefresh} setTriggerRefresh={setTriggerRefresh} />
        ), ACTION_CELL_STYLE),
      },
    },
  };
};

export default getFilterMeta;
